// @ts-nocheck
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import * as React from "react";

export type LinkModalTarget = "_self" | "_blank";

export interface LinkModalOptions {
    key: string;
    href?: string;
    title: string;
    target: LinkModalTarget;
}

const openUrl = (href: string, target: LinkModalTarget) => {
    if (target === "_blank") {
        window.open(href, "_blank", "noopener,noreferrer");
    } else {
        window.location.assign(href);
    }
};

export const useLinkModal = () => {
    const [isModalOpen, setIsModalOpen] = React.useState<SafeDictionary<boolean>>({});
    const [pendingHref, setPendingHref] = React.useState<string | null>(null);
    const [pendingTitle, setPendingTitle] = React.useState<string>("");
    const [pendingTarget, setPendingTarget] = React.useState<LinkModalTarget>("_self");

    const openModal = ({ key, href, title, target }: LinkModalOptions) => {
        if (!href) {
            return;
        }

        setPendingHref(href);
        setPendingTitle(title);
        setPendingTarget(target);
        setIsModalOpen(current => ({ ...current, [key]: true }));
    };

    const confirmModal = (key: string) => {
        if (pendingHref) {
            openUrl(pendingHref, pendingTarget);
        }

        setIsModalOpen(current => ({ ...current, [key]: false }));
    };

    const closeModal = (key: string) => {
        setIsModalOpen(current => ({ ...current, [key]: false }));
        setPendingHref(null);
        setPendingTitle("");
    };

    return {
        isModalOpen,
        pendingTitle,
        openModal,
        confirmModal,
        closeModal,
    };
};
